import React, { useMemo } from 'react';
import {
  useConversationTriageRuns,
  useResolveTriageAction,
} from 'src/graphql/entities/conversation-triage-run';
import { UserGroupRules } from 'src/graphql/entities/group-rules/group-rules.types';
import { useChatCommonData } from 'src/pages/Conversations/Chat/registry/common-data-context';
import { TriageRunContext, TriageRunContextValue } from './triage-run-context';

export const TriageRunProvider = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  const conversationId = useChatCommonData((s) => s.conversationId);
  const partnerId = useChatCommonData((s) => s.partnerId);
  const canViewTriage = useChatCommonData((s) =>
    Boolean(s.groupRules[UserGroupRules.AccessToViewTriageIntelligence]),
  );

  const partnerIdNumber = useMemo(() => {
    const parsed = Number(partnerId);
    return Number.isFinite(parsed) ? parsed : null;
  }, [partnerId]);

  const { triageRuns, loading, error } = useConversationTriageRuns({
    conversationId,
    partnerId: partnerIdNumber,
    skip: !conversationId || !canViewTriage,
  });

  const { isResolving, accept, dismiss, retry } = useResolveTriageAction();

  const value = useMemo<TriageRunContextValue>(
    () => ({
      runs: triageRuns,
      isLoading: loading,
      error,
      isResolving,
      accept,
      dismiss,
      retry,
    }),
    [triageRuns, loading, error, isResolving, accept, dismiss, retry],
  );

  return <TriageRunContext.Provider value={value}>{children}</TriageRunContext.Provider>;
};
